// @flow

import { type3, types as T } from "./action_types";
import * as API from "../common/api";
import { partial } from "../common/utils";
import { getAccessToken } from "../common/aws_lib";

export function setRoute(data) {
  return {
    type: T.SET_ROUTE,
    data
  };
}

export function setHeader(factory) {
  return (dispatch, getState) => {
    const { header } = getState();
    const restore = () => {
      dispatch({
        type: T.SET_HEADER,
        data: header
      });
    };

    return dispatch({
      type: T.SET_HEADER,
      data: factory(restore, header)
    });
  };
}

export function pushToInternalStack(url, beforePop) {
  return {
    type: T.PUSH_TO_INTERNAL_STACK,
    data: { url, beforePop }
  };
}

export function popFromInternalStack(history) {
  return (dispatch, getState) => {
    const { internalStack } = getState();
    const lastItem = internalStack[internalStack.length - 1];

    if (lastItem && lastItem.beforePop) {
      lastItem.beforePop(lastItem);
    }

    setTimeout(() => {
      history.push(lastItem.url);
    }, 0);

    return dispatch({
      type: T.POP_FROM_INTERNAL_STACK,
      data: null
    });
  };
}

export function clearInternalStack() {
  return {
    type: T.CLEAR_INTERNAL_STACK,
    data: null
  };
}

export function clearAppData() {
  return {
    type: T.CLEAR_APP_DATA,
    data: null
  };
}

export function setUserData(data) {
  return {
    type: T.SET_USER_DATA,
    data
  };
}

export function setOrderFormData(data) {
  return {
    type: T.SET_ORDER_FORM_DATA,
    data
  };
}

export function setBookingFormData(data) {
  return {
    type: T.SET_BOOKING_FORM_DATA,
    data
  };
}

export function loadGallery() {
  return {
    types: type3("LOAD_GALLERY"),
    promise: () => API.GetGallery().then(data => data)
  };
}

export function loadUntagged() {
  return {
    types: type3("LOAD_UNTAGGED"),
    promise: () => API.GetUntagged().then(data => data)
  };
}

export function loadGalleryPhoto(photoId) {
  return {
    types: type3("LOAD_GALLERY_PHOTO"),
    promise: () => API.GetGalleryPhoto(photoId).then(data => data)
  };
}

export function loadCategories() {
  return {
    types: type3("LOAD_CATEGORIES"),
    promise: () => API.GetCategories().then(data => data)
  };
}

export function loadSettings() {
  return {
    types: type3("LOAD_SETTINGS"),
    promise: () => API.GetSettings().then(data => data)
  };
}

// export function loadUserInfo() {
//   return (dispatch, getState) => API.getUserInfo()
//     .then(userInfo => dispatch({
//       type: T.SET_USER_DATA,
//       data: { userInfo }
//     }));
// }

export function setLoading(loading) {
  return {
    type: T.SET_LOADING,
    data: loading
  };
}

export function wrapLoading(props, promise) {
  props.setLoading(true);
  const cancel = () => props.setLoading(false);

  return promise.then(
    data => {
      cancel();
      return data;
    },
    e => {
      cancel();
      throw e;
    }
  );
}
